// Takes Taken data from server and stores it in object with helper methods for accessing it.

import FrontEndModel from './FrontEndModel';

class TakenAction extends FrontEndModel {
}

export default TakenAction;
